import { createIcon } from '../utils';

export const StarIcon = createIcon(
  ({ ref, className, width, height, ...rest }) => (
    <svg
      ref={ref}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M4.12501 20.1668V15.5835M4.12501 6.41683V1.8335M1.83334 4.12516H6.41668M1.83334 17.8752H6.41668M11.9167 2.75016L10.327 6.88329C10.0685 7.55541 9.93925 7.89148 9.73825 8.17416C9.5601 8.42469 9.34121 8.64359 9.09067 8.82173C8.80799 9.02273 8.47193 9.15199 7.7998 9.4105L3.66668 11.0002L7.7998 12.5898C8.47193 12.8483 8.80799 12.9776 9.09067 13.1786C9.34121 13.3567 9.5601 13.5756 9.73825 13.8262C9.93925 14.1088 10.0685 14.4449 10.327 15.117L11.9167 19.2502L13.5063 15.117C13.7649 14.4449 13.8941 14.1088 14.0951 13.8262C14.2733 13.5756 14.4921 13.3567 14.7427 13.1786C15.0254 12.9776 15.3614 12.8483 16.0336 12.5898L20.1667 11.0002L16.0336 9.4105C15.3614 9.15199 15.0254 9.02273 14.7427 8.82173C14.4921 8.64359 14.2733 8.42469 14.0951 8.17416C13.8941 7.89148 13.7649 7.55541 13.5063 6.88329L11.9167 2.75016Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  {
    displayName: 'StarIcon',
    defaultSize: 22,
    defaultVariant: 'primary',
  },
);
